import { render, staticRenderFns } from "./submit_python.vue?vue&type=template&id=552bd138&scoped=true"
import script from "./submit_python.vue?vue&type=script&lang=js"
export * from "./submit_python.vue?vue&type=script&lang=js"
import style0 from "./submit_python.vue?vue&type=style&index=0&id=552bd138&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552bd138",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552bd138')) {
      api.createRecord('552bd138', component.options)
    } else {
      api.reload('552bd138', component.options)
    }
    module.hot.accept("./submit_python.vue?vue&type=template&id=552bd138&scoped=true", function () {
      api.rerender('552bd138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/submit_python.vue"
export default component.exports